import React from 'react';
import PropTypes from 'prop-types';
import './SelectRecovery.scss';

const SelectRecovery = ({ title, active, func }) => {
    return (
        <div className="type-recovery">
            <p className='me-3 mb-0'>{title + ':'}</p>
            <p>
                <span onClick={() => func(true)} className={`me-3 ${active ? ' active' : ''}`}> по номеру телефона</span>
                <span onClick={() => func(false)} className={`${!active ? 'active' : ''}`}> по E-mail</span>
            </p>
        </div>
    );
};

export default SelectRecovery;

SelectRecovery.propTypes = {
    title: PropTypes.string,
    active: PropTypes.bool,
    func: PropTypes.func
};